// 系统参数缓存
import localStorage from '@utils/localstorage'
const sysParams = {
	state: {
		ifyik: '',			// 医卡模式（0：无卡，1：有卡）
		iffsd: '',			// 分时段挂号（0：停用，1：启用）
		ifyyorqhpay: '',	// 预约或取号支付（0：预约，1：取号）
		ifksorysgh: ''	,	// 挂号模式（0：科室，1：专家）
		ifmenzth: '',		// 门诊退号（0：停用，1：启用）
		ifdzjkk: '',		// 电子健康卡（0：停用，1：启用）
		ifybmzgh: '',		// 医保移动支付门诊挂号（0：停用，1：启用）
		ifybmzjf: '',		// 医保移动支付门诊缴费（0：停用，1：启用）
	},

	mutations: {
		SET_IFYIK: (state, ifyik) => {
			state.ifyik = ifyik
		},
		SET_IFFSD: (state, iffsd) => {
			state.iffsd = iffsd
		},
		SET_IFYYORQHPAY: (state, ifyyorqhpay) => {
			state.ifyyorqhpay = ifyyorqhpay
		},
		SET_IFKSORYSGH: (state, ifksorysgh) => {
			state.ifksorysgh = ifksorysgh
		},
		SET_IFMENZTH: (state, ifmenzth) => {
			state.ifmenzth = ifmenzth
		},
		SET_IFDZJKK: (state, ifdzjkk) => {
			state.ifdzjkk = ifdzjkk
		},
		SET_IFYBMZGH: (state, ifybmzgh) => {
			state.ifybmzgh = ifybmzgh
		},
		SET_IFYBMZJF: (state, ifybmzjf) => {
			state.ifybmzjf = ifybmzjf
		},
	},

	actions: {
		SetIfyik({ commit }, ifyik) {
			commit('SET_IFYIK', ifyik)
		},
		GetIfyik({ state }) {
			return state.ifyik
		},
		SetIffsd({ commit }, iffsd) {
			commit('SET_IFFSD', iffsd)
		},
		GetIffsd({ state }) {
			return state.iffsd
		},
		SetIfyyorqhpay({ commit }, ifyyorqhpay) {
			commit('SET_IFYYORQHPAY', ifyyorqhpay)
		},
		GetIfyyorqhpay({ state }) {
			return state.ifyyorqhpay
		},
		SetIfksorysgh({ commit }, ifksorysgh) {
			commit('SET_IFKSORYSGH', ifksorysgh)
		},
		GetIfksorysgh({ state }) {
			return state.ifksorysgh
		},
		SetIfmenzth({ commit }, ifmenzth) {
			commit('SET_IFMENZTH', ifmenzth)
		},
		GetIfmenzth({ state }) {
			return state.ifmenzth
		},
		SetIfdzjkk({ commit }, ifdzjkk) {
			commit('SET_IFDZJKK', ifdzjkk)
		},
		GetIfdzjkk({ state }) {
			return state.ifdzjkk
		},
		SetIfybmzgh({ commit }, ifybmzgh) {
			commit('SET_IFYBMZGH', ifybmzgh)
		},
		GetIfybmzgh({ state }) {
			return state.ifybmzgh
		},
		SetIfybmzjf({ commit }, ifybmzjf) {
			commit('SET_IFYBMZJF', ifybmzjf)
		},
		GetIfybmzjf({ state }) {
			return state.ifybmzjf
		},
	}
}

export default sysParams
